import { breakpoints } from '../components/breakpoints';

export default function columns() {
  /**
   * Count number of columns
   */
  $('.wp-block-columns').each(function () {
    const cols = $(this).find('> .wp-block-column').length;
    $(this)
      .find('> .wp-block-column')
      .each(function () {
        //Use classes instead of harcoded percentages
        const width = Math.round(parseFloat($(this).css('flex-basis')));
        if (width == 50) {
          $(this).addClass('col-md-6');
          $(this).removeAttr('style');
        } else if (width == 33) {
          $(this).addClass('col-md-6');
          $(this).addClass('col-xl-4');
          $(this).removeAttr('style');
        } else if (width == 67) {
          $(this).addClass('col-md-6');
          $(this).addClass('col-xl-8');
          $(this).removeAttr('style');
        } else if (width == 40) {
          $(this).addClass('col-md-5 col-xl-5');
          $(this).removeAttr('style');
        } else if (width == 60) {
          $(this).addClass('col-md-7 col-xl-7');
          $(this).removeAttr('style');
        } else {
          $(this).addClass('col-md-' + parseInt(12 / cols));
        }
      });
  });
}
